export default __webpack_public_path__ + "static/media/sights.af9dd6b4.svg";